<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="mt-3">Aggiungi nuovo prodotto/servizio</h3>
<p>Le prestazioni salvate saranno disponibili durante la creazione di nuove fatture o preventivi.</p>

<form 
  #SavedProductForm="ngForm" 
  class="savedproduct-form"
  (ngSubmit)="onSubmit()"
  >

<mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
  <mat-card-content>

        <h5 class="mb-3">Inserisci i dati:</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome</mat-label>
            <input
              matInput
              [(ngModel)]="newSavedProduct.name"
              name="name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Tipo</mat-label>
            <mat-select
              [(ngModel)]="newSavedProduct.type"
              name="type"
              required
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Unità di misura</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newSavedProduct.units"
              name="units"
            />
          </mat-form-field>

        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Descrizione</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newSavedProduct.description"
              name="description"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Prezzo unitario</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newSavedProduct.unit_price"
              name="unit_price"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Percentuale IVA</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newSavedProduct.iva_percentage"
              name="iva_percentage"
              disabled
            />
          </mat-form-field>
        </div>

        <div class="mb-2 d-flex flex-column align-self-end">
          <div class="mt-2 mb-2 d-flex align-self-end">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!SavedProductForm.valid"
              class="mt-2 me-3"
            >
            <mat-icon>save</mat-icon>
              Salva
            </button>
          </div>
        </div>

  </mat-card-content>
</mat-card>


</form>